import * as $ from 'jquery';

const $PubSub = $({});
let $Initialized = false;

export class RuntimeConnectedShadeUtils {

    public static ModalVisibleEventName = "modal.visible";

    public static AuthoringToolDirtyEventName = "authoring-tool.dirty";

    public static AuthoringToolMaskEventName = "authoring-tool.mask";

    public static AuthoringToolErrorEventName = "authoring-tool.error";

    static initialize() {
        if ($Initialized) {
            return;
        }

        window.addEventListener('message', this.OnMessage);
        $Initialized = true;
    }

    public static trigger(event: string, data: any): boolean {
        let frame = <HTMLFrameElement>$("#authoringSurfaceHost")[0];
        if (!frame) {
            return false;
        }

        frame.contentWindow.postMessage({
            action: event,
            ...data
        }, '*');
        
        return true;
    }

    public static on(event: string, callback: (eventObject: JQueryEventObject, ...data: any[]) => any) {
        $PubSub.on(event, callback);
    }

    public static off(event: string, callback: (eventObject: JQueryEventObject, ...data: any[]) => any) {
        $PubSub.on(event, callback);
    }

    private static OnMessage(e: MessageEvent) {
        if (!e.data['action']) {
            return;
        }

        $PubSub.trigger(e.data.action, e.data);
    }
}


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/RuntimeConnectedShadeUtils.ts